import { useEffect } from 'react';

function useScrollbarWidth() {
  useEffect(() => {
    const scrollbarSize =
      window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.style.setProperty(
      '--is-scrollwidth',
      `${scrollbarSize}px`
    );

    return () => {
      document.documentElement.style.removeProperty('--is-scrollwidth');
    };
  }, []);
}

export default useScrollbarWidth;
